import { useMemo } from "react";
import { Product, type Prices } from "@b2bportal/purchase-api";
import {
  type CartQuoteBreakdownProducts,
  CartSelectors,
  getCartQuoteBreakdownProducts,
} from "@checkout/states";
import { useCheckoutStateSelector } from "../context";

export const useCheckoutFintechProducts = (): CartQuoteBreakdownProducts => {
  const cartQuoteBreakdownProducts = useCheckoutStateSelector(
    getCartQuoteBreakdownProducts
  );

  const selectedFintechProducts = useCheckoutStateSelector(
    CartSelectors.getCartSelectedProducts
  );

  return useMemo(() => {
    const merged = {
      ...selectedFintechProducts,
      ...cartQuoteBreakdownProducts,
    };

    // If both legacy and HTS CFAR exist, only use HTS
    if (merged[Product.HtsLodgingCfar] && merged[Product.LodgingCfar]) {
      delete merged[Product.LodgingCfar];
    }

    return merged;
  }, [cartQuoteBreakdownProducts, selectedFintechProducts]);
};

export const useCheckoutFintechProductsTotal = (): Prices => {
  const checkoutFintechProducts = useCheckoutFintechProducts();

  return useMemo(
    () =>
      Object.values(checkoutFintechProducts)
        .filter((x) => x != null)
        .reduce(
          (acc, product) => {
            acc.fiat.value += product.totalPremiumAmount.fiat.value;
            acc.fiat.currencyCode =
              product.totalPremiumAmount.fiat.currencyCode;
            acc.fiat.currencySymbol =
              product.totalPremiumAmount.fiat.currencySymbol;

            return acc;
          },
          {
            fiat: {
              value: 0,
              currencySymbol: "",
              currencyCode: "",
            },
            accountSpecific: {},
          }
        ),
    [checkoutFintechProducts]
  );
};
